const FALLBACK_LANGUAGE = 'en';

function normalizeTag(rawTag: string): string | undefined {
  if (!rawTag) {
    return undefined;
  }

  const parts = rawTag
    .trim()
    .toLowerCase()
    .replace(/_/g, '-')
    .split('-')
    .filter(Boolean);

  if (parts.length === 0) {
    return undefined;
  }

  const primary = parts[0];
  let region: string | undefined;

  for (let i = 1; i < parts.length; i += 1) {
    const part = parts[i];
    if (part.length === 1) {
      break;
    }
    if (/^[a-z]{4}$/.test(part)) {
      continue;
    }
    if (/^[a-z]{2}$/.test(part) || /^\d{3}$/.test(part)) {
      region = part;
      break;
    }
  }

  return region ? `${primary}-${region}` : primary;
}

export function matchLanguage(
  rawTag: string | undefined | null,
  catalog: readonly string[],
): string | undefined {
  const normalized = normalizeTag(rawTag ?? '');
  if (!normalized) {
    return undefined;
  }
  if (catalog.includes(normalized)) {
    return normalized;
  }
  const primary = normalized.split('-')[0];
  if (catalog.includes(primary)) {
    return primary;
  }
  return undefined;
}

export function resolveLanguage(
  rawTagOrTags: string | readonly string[],
  catalog: readonly string[],
): string {
  const tags = Array.isArray(rawTagOrTags) ? rawTagOrTags : [rawTagOrTags];
  for (const rawTag of tags) {
    const matched = matchLanguage(rawTag, catalog);
    if (matched) {
      return matched;
    }
  }
  return FALLBACK_LANGUAGE;
}

export function lookupTranslatedName(
  translatedNames: Record<string, string | undefined | null> | undefined | null,
  rawTag: string | undefined | null,
  defaultName: string,
  catalog: readonly string[],
): string {
  const languageCode = resolveLanguage(rawTag ?? '', catalog);
  if (!translatedNames) {
    return defaultName;
  }
  for (const [storedKey, name] of Object.entries(translatedNames)) {
    if (name && matchLanguage(storedKey, catalog) === languageCode) {
      return name;
    }
  }
  return defaultName;
}
